import React from 'react';
import './AuthBootLoader.css';

export default function AuthBootLoader() {
  return (
    <div className="auth-boot-loader" role="status" aria-live="polite">
      <div className="auth-boot-logo" aria-hidden="true">🛡️</div>
      <div className="auth-boot-spinner" aria-hidden="true" />
      <span className="auth-boot-label">Loading…</span>
    </div>
  );
}
